import { hc } from "hono/client";
import type { app } from ".";

export const client = hc<typeof app>("/", {
	init: {
		credentials: "include",
	},
}).api;
